import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";
import { useParams } from "react-router-dom";

export const useGetQuestChapterDetail = () => {
  const [questChapterDetail, setQuestChapterDetail] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { chapterId } = useParams();
  const { axiosInstance } = useAxios();

  const getStudentQuestChapterDetail = async () => {
    try {
      setLoading(true);
      setError("");

      const response = await axiosInstance.get(
        `${TENANT_DOMAIN}/student/quest/chapter/${chapterId}`
      );

      const data = response?.data?.data;
      setQuestChapterDetail(data ?? null);
    } catch (err) {
      setQuestChapterDetail(null);

      if (err?.response?.status === 500) {
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        setError(err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN);
      }
    } finally {
      setLoading(false);
    }
  };

  return { questChapterDetail, loading, error, getStudentQuestChapterDetail };
};
